import React, { useState } from 'react';
import { MessageCircle, Menu, X, Phone, ShieldCheck, Home, Key, BookOpen, User } from 'lucide-react';
import { useProperties } from '../context/PropertyContext';

export const Navbar = ({ activeRoute, onNavigate }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { getWhatsAppLink } = useProperties();

  const navItems = [
    { id: 'home', label: 'Inicio', icon: Home },
    { id: 'properties', label: 'Propiedades', icon: Key },
    { id: 'sell', label: 'Vende / Renta', icon: ShieldCheck },
    { id: 'guide', label: 'Guía Inmobiliaria', icon: BookOpen },
    { id: 'about', label: 'Nosotros', icon: User }
  ];

  const handleNavClick = (routeId) => {
    onNavigate(routeId);
    setMobileMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header className="header" role="banner">
      <div className="container header-container">
        {/* Brand Institutional Logo */}
        <a
          href="#home"
          className="brand-logo"
          onClick={(e) => {
            e.preventDefault();
            handleNavClick('home');
          }}
          aria-label="EM Asesoría Inmobiliaria y Jurídica - Inicio"
        >
          <img
            src="/EM Asesorias.svg"
            alt="Isotipo Oficial EM Asesoría Inmobiliaria y Jurídica - Lic. Edgar Molina"
            className="brand-logo-img"
            width="54"
            height="54"
            fetchPriority="high"
          />
          <div className="brand-text">
            <span className="brand-title">
              EM <span>Asesoría</span>
            </span>
            <span className="brand-subtitle">Inmobiliaria & Jurídica</span>
          </div>
        </a>

        {/* Desktop Navigation Links */}
        <nav className="desktop-nav" aria-label="Navegación principal">
          <ul className="nav-links">
            {navItems.map((item) => (
              <li key={item.id}>
                <a
                  href={`#${item.id}`}
                  className={`nav-link ${activeRoute === item.id ? 'active' : ''}`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick(item.id);
                  }}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        {/* Header Actions & WhatsApp CTA */}
        <div className="header-actions">
          <a
            href={getWhatsAppLink('Hola Lic. Edgar Molina, vi su plataforma asesoriasem.com y deseo solicitar asesoría inmobiliaria/jurídica.')}
            target="_blank"
            rel="noopener noreferrer"
            className="nav-cta-whatsapp"
            aria-label="Contactar por WhatsApp al 6272792964"
          >
            <MessageCircle size={18} />
            <span>627 279 2964</span>
          </a>

          {/* Mobile Hamburger Button */}
          <button
            type="button"
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-expanded={mobileMenuOpen}
            aria-label={mobileMenuOpen ? 'Cerrar menú de navegación' : 'Abrir menú de navegación'}
          >
            {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation Drawer */}
      <div
        className={`mobile-nav-drawer ${mobileMenuOpen ? 'open' : ''}`}
        aria-hidden={!mobileMenuOpen}
        inert={!mobileMenuOpen ? '' : undefined}
      >
        <ul className="mobile-nav-list">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <li key={item.id} className="mobile-nav-item">
                <a
                  href={`#${item.id}`}
                  className={activeRoute === item.id ? 'active' : ''}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick(item.id);
                  }}
                >
                  <span style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <Icon size={20} color="var(--color-accent)" />
                    {item.label}
                  </span>
                </a>
              </li>
            );
          })}
        </ul>

        <div className="mobile-drawer-contact">
          <p style={{ color: 'var(--color-text-muted)', fontSize: '0.85rem' }}>
            Atención personalizada por el <strong>Lic. Edgar Molina</strong> en Hidalgo del Parral, Chihuahua.
          </p>
          <a
            href={getWhatsAppLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-whatsapp btn-full"
          >
            <MessageCircle size={20} />
            WhatsApp: 627 279 2964
          </a>
          <a href="tel:6272792964" className="btn btn-outline btn-full">
            <Phone size={18} />
            Llamada Telefónica
          </a>
        </div>
      </div>
    </header>
  );
};
